import React from 'react';

import useMediaQuery from 'hooks/use-media-query';
import { MapContainer, OrderIssues } from 'pages/order-confirmation/common';
import Map from 'pages/order-confirmation/map';
import { IConfirmationUIProps } from 'pages/order-confirmation/order-confirmation';
import { useDeliveryConfirmationContext } from 'state/delivery-confirmation';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

import DeliveryDetails from './delivery-details';
import { FixedMapWindow, ScrollContainer, ScrollContainerInner, StyledOrderIssues } from './styled';

const DeliveryConfirmation: React.FC<IConfirmationUIProps> = ({ serverOrder, isInsideModal }) => {
  const isShowingOrderingIssue = useFlag(LaunchDarklyFlag.SHOW_ORDERING_ISSUE);

  const { bringgUuids } = useDeliveryConfirmationContext();
  const isMobile = useMediaQuery('mobile');

  const isDeliveryDesktop = !(isInsideModal || isMobile);

  return (
    <MapContainer isDeliveryDesktop={isDeliveryDesktop}>
      <FixedMapWindow isDeliveryDesktop={isDeliveryDesktop}>
        <Map bringgUuids={bringgUuids} serverOrder={serverOrder} />
      </FixedMapWindow>

      {!isDeliveryDesktop && (
        <ScrollContainer>
          <ScrollContainerInner>
            {serverOrder.delivery && <DeliveryDetails serverOrder={serverOrder} />}
            {isShowingOrderingIssue && (
              <StyledOrderIssues>
                <OrderIssues />
              </StyledOrderIssues>
            )}
          </ScrollContainerInner>
        </ScrollContainer>
      )}
    </MapContainer>
  );
};

export default DeliveryConfirmation;
